import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { triggerExtendedTranscription, fetchExtendedTranscriptionInfo } from 'flow/actions/transcription-actions';
import { setSnackbar } from 'flow/actions/app-actions';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { selectCallRecordFromKey } from 'flow/selectors/call-selectors';
import ButtonGenerate from './ButtonGenerate';
import { jsx as _jsx } from "react/jsx-runtime";
var ButtonGenerateExtendedTranscription = function ButtonGenerateExtendedTranscription(_ref) {
  var callRecordKey = _ref.callRecordKey,
    transcriptionIsPending = _ref.transcriptionIsPending,
    onAwaitTranscriptionConfirmation = _ref.onAwaitTranscriptionConfirmation,
    onClickGenerate = _ref.onClickGenerate;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var queryClient = useQueryClient();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    userHasRequestedGeneration = _useState2[0],
    setUserHasRequestedGeneration = _useState2[1];
  var callRecord = useAppSelector(function (state) {
    return selectCallRecordFromKey(state, callRecordKey);
  });
  var recordedCallKey = callRecord === null || callRecord === void 0 ? void 0 : callRecord.getIn(['recordedCall', 'key']);
  if (!recordedCallKey || !callRecord) return null;
  var isPersonal = !!callRecord.getIn(['recordedCall', 'isPersonalRecording']);
  var extendedTranscriptionKey = callRecord.getIn(['extendedTranscriptionInfo', 'extendedTranscriptionKey']);
  var handleClick = function handleClick() {
    onClickGenerate === null || onClickGenerate === void 0 || onClickGenerate();
    setUserHasRequestedGeneration(true);
    onAwaitTranscriptionConfirmation === null || onAwaitTranscriptionConfirmation === void 0 || onAwaitTranscriptionConfirmation();
    var callRecordQueueKey = callRecord.getIn(['queue', 'key']);
    dispatch(triggerExtendedTranscription(recordedCallKey, isPersonal)).then(function () {
      // Fetch extendedTranscriptionInfo (with key and pending: true)
      // to put it in the store, which starts the polling flow.
      void dispatch(fetchExtendedTranscriptionInfo(callRecordKey, callRecordQueueKey));
      if (extendedTranscriptionKey) {
        void queryClient.invalidateQueries({
          queryKey: ['extendedTranscription', extendedTranscriptionKey]
        });
      }
    })["catch"](function (error) {
      setUserHasRequestedGeneration(false);
      if (error.status === 402 && extendedTranscriptionKey) {
        queryClient.setQueryData(['extendedTranscription', extendedTranscriptionKey], function (prev) {
          return prev ? _objectSpread(_objectSpread({}, prev), {}, {
            resultCode: 'QUOTA_EXCEEDED'
          }) : {
            resultCode: 'QUOTA_EXCEEDED'
          };
        });
      }
      dispatch(setSnackbar({
        message: i18next.t(error.status === 402 ? 'ai.transcript.quota_exceeded' : 'ai.transcript.failed')
      }));
    });
  };
  var transcriptionIsBeingGenerated = transcriptionIsPending || userHasRequestedGeneration;
  return /*#__PURE__*/_jsx(ButtonGenerate, {
    generationIsInProgress: transcriptionIsBeingGenerated,
    onClick: handleClick
  });
};
export default ButtonGenerateExtendedTranscription;